export default {"src":"/_next/static/media/logo.05d7cb18.svg","height":141,"width":1113,"blurWidth":0,"blurHeight":0};